var _path, _g, _path2, _g2, _circle, _circle2, _g3, _path3, _circle3, _circle4, _g4, _path4, _circle5, _circle6, _g5, _path5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoCompany = function SvgLogoCompany(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 127",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4695 24.2262C53.3136 23.7792 54.3254 23.7842 55.165 24.2394L98.5308 47.7538L71.8415 61.8887L27.1315 37.6455L52.4695 24.2262Z",
    fill: "url(#logo-company_svg__paint0_linear_9035_2253)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter0_i_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1315 92.1015V37.5986L72.0307 61.6883V118.754L29.5508 96.1309C28.0618 95.338 27.1315 93.7885 27.1315 92.1015Z",
    fill: "url(#logo-company_svg__paint1_linear_9035_2253)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92.038V55L72.0308 75.5635V117.164C72.0308 118.025 71.1139 118.576 70.3537 118.172L29.7251 96.5729C28.0481 95.6814 27 93.9372 27 92.038Z",
    fill: "url(#logo-company_svg__paint2_linear_9035_2253)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter1_di_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6019 103.372V47.7539L72.0308 61.842V118.908L97.0639 105.904C98.0089 105.413 98.6019 104.437 98.6019 103.372Z",
    fill: "#88C1E0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.1234,
    cy: 118.866,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint3_linear_9035_2253)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask0_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 115,
    width: 8,
    height: 8
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.1233,
    cy: 118.866,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint4_linear_9035_2253)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask0_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter2_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8466 120.37C73.5666 121.67 73.7205 117.612 72.5132 116.424C71.3059 115.235 69.1946 117.365 70.4747 116.065C71.7548 114.765 73.7712 114.675 74.9784 115.863C76.1857 117.052 76.1267 119.07 74.8466 120.37Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter3_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5577 116.551C76.0958 117.977 71.6929 117.655 70.5325 118.907C69.3721 120.158 71.8935 122.51 70.3554 121.084C68.8173 119.658 68.5111 117.487 69.6716 116.235C70.832 114.984 73.0196 115.125 74.5577 116.551Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter4_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8662 120.912C68.9651 120.161 71.196 121.71 72.6777 121.905C74.1594 122.101 74.3307 120.868 74.2318 121.619C74.1329 122.369 72.8516 122.819 71.3699 122.624C69.8882 122.429 68.7673 121.662 68.8662 120.912Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter5_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.342 119.93C74.1345 121.955 72.711 118.446 71.6186 118.334C70.5263 118.222 70.1787 121.549 70.3862 119.525C70.5937 117.5 71.6475 115.95 72.7399 116.062C73.8322 116.174 74.5495 117.906 74.342 119.93Z",
    fill: "#91EEFF"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4633 115.329C71.2031 115.165 68.6695 115.728 68.6166 119.288C68.8569 118.094 69.9628 115.631 72.4633 115.329Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.1234,
    cy: 104.866,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint5_linear_9035_2253)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask1_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 101,
    width: 8,
    height: 8
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.1233,
    cy: 104.866,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint6_linear_9035_2253)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask1_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter6_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.847 106.37C99.5666 107.67 99.7205 103.612 98.5132 102.424C97.3059 101.235 95.1946 103.365 96.4747 102.065C97.7548 100.765 99.7712 100.675 100.978 101.863C102.186 103.052 102.127 105.07 100.847 106.37Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter7_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.558 102.551C102.096 103.977 97.6929 103.655 96.5325 104.907C95.3721 106.158 97.8935 108.51 96.3554 107.084C94.8173 105.658 94.5111 103.487 95.6716 102.235C96.832 100.984 99.0196 101.125 100.558 102.551Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter8_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8662 106.912C94.9651 106.161 97.196 107.71 98.6777 107.905C100.159 108.101 100.331 106.868 100.232 107.619C100.133 108.369 98.8516 108.819 97.3699 108.624C95.8882 108.429 94.7673 107.662 94.8662 106.912Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter9_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.342 105.93C100.134 107.955 98.711 104.446 97.6186 104.334C96.5263 104.222 96.1787 107.549 96.3862 105.525C96.5937 103.5 97.6475 101.95 98.7399 102.062C99.8322 102.174 100.55 103.906 100.342 105.93Z",
    fill: "#91EEFF"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4633 101.329C97.2031 101.165 94.6695 101.728 94.6166 105.288C94.8569 104.094 95.9628 101.631 98.4633 101.329Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1234,
    cy: 94.8657,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint7_linear_9035_2253)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask2_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 91,
    width: 8,
    height: 8
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1233,
    cy: 94.8657,
    r: 3.86573,
    fill: "url(#logo-company_svg__paint8_linear_9035_2253)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask2_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter10_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8466 96.3696C28.5666 97.6697 28.7205 93.6124 27.5132 92.4237C26.3059 91.235 24.1946 93.365 25.4747 92.0649C26.7548 90.7649 28.7712 90.6746 29.9784 91.8633C31.1857 93.052 31.1267 95.0695 29.8466 96.3696Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter11_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5577 92.5508C31.0958 93.9767 26.6929 93.6549 25.5325 94.9066C24.3721 96.1584 26.8935 98.5097 25.3554 97.0838C23.8173 95.6579 23.5111 93.4872 24.6716 92.2355C25.832 90.9837 28.0196 91.1249 29.5577 92.5508Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter12_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8662 96.9115C23.9651 96.161 26.196 97.7101 27.6777 97.9053C29.1594 98.1006 29.3307 96.868 29.2318 97.6185C29.1329 98.3691 27.8516 98.8193 26.3699 98.624C24.8882 98.4288 23.7673 97.6621 23.8662 96.9115Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter13_f_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.342 95.9303C29.1345 97.9547 27.711 94.4462 26.6186 94.3342C25.5263 94.2222 25.1787 97.5492 25.3862 95.5248C25.5937 93.5004 26.6475 91.9502 27.7399 92.0621C28.8322 92.1741 29.5495 93.906 29.342 95.9303Z",
    fill: "#91EEFF"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4633 91.3288C26.2031 91.1651 23.6695 91.7278 23.6166 95.2881C23.8569 94.0944 24.9628 91.6312 27.4633 91.3288Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask3_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 35,
    width: 29,
    height: 73
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90.4754V36L50.8208 50.1594V107.225L26.455 94.5236C24.9462 93.7371 24 92.1768 24 90.4754Z",
    fill: "#4C579B",
    stroke: "#27468B",
    strokeWidth: 0.570655
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask3_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter14_d_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.332 40.8467V99.4102",
    stroke: "#27468B",
    strokeWidth: 0.570655
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask4_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 51,
    width: 29,
    height: 72
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105.654V52L78.8208 65.9606V122.225L54.4784 109.714C52.9567 108.932 52 107.365 52 105.654Z",
    fill: "#4C579B",
    stroke: "#27468B",
    strokeWidth: 0.570655
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask4_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter15_d_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.332 56.7783V114.52",
    stroke: "#27468B",
    strokeWidth: 0.570655
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask5_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 46,
    width: 29,
    height: 71
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99.6468V47L68.8208 60.7171V116L44.5073 103.722C42.9697 102.945 42 101.369 42 99.6468Z",
    fill: "#4C579B",
    stroke: "#27468B",
    strokeWidth: 0.570655
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask5_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter16_d_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.332 51.6953V108.429",
    stroke: "#27468B",
    strokeWidth: 0.570655
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-company_svg__mask6_9035_2253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 41,
    width: 29,
    height: 71
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94.6468V42L59.8208 55.7171V111L35.5073 98.7219C33.9697 97.9454 33 96.3694 33 94.6468Z",
    fill: "#4C579B",
    stroke: "#27468B",
    strokeWidth: 0.570655
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-company_svg__mask6_9035_2253)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-company_svg__filter17_d_9035_2253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.332 46.6953V103.429",
    stroke: "#27468B",
    strokeWidth: 0.570655
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter0_i_9035_2253",
    x: 27.1315,
    y: 37.5986,
    width: 44.8993,
    height: 81.7259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.570655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.285328
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter1_di_9035_2253",
    x: 68.0308,
    y: 47.7539,
    width: 34.5712,
    height: 79.1533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9035_2253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9035_2253",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.570655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.285328
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter2_f_9035_2253",
    x: 68.8739,
    y: 113.825,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter3_f_9035_2253",
    x: 67.765,
    y: 114.179,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter4_f_9035_2253",
    x: 67.6574,
    y: 119.505,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter5_f_9035_2253",
    x: 66.5494,
    y: 112.277,
    width: 11.6082,
    height: 12.0616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter6_f_9035_2253",
    x: 94.8739,
    y: 99.8247,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter7_f_9035_2253",
    x: 93.765,
    y: 100.179,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter8_f_9035_2253",
    x: 93.6574,
    y: 105.505,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter9_f_9035_2253",
    x: 92.5494,
    y: 98.2768,
    width: 11.6082,
    height: 12.0616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter10_f_9035_2253",
    x: 23.8739,
    y: 89.8247,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter11_f_9035_2253",
    x: 22.765,
    y: 90.1792,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter12_f_9035_2253",
    x: 22.6574,
    y: 95.5053,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter13_f_9035_2253",
    x: 21.5494,
    y: 88.2768,
    width: 11.6082,
    height: 12.0616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_9035_2253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter14_d_9035_2253",
    x: 34.0468,
    y: 40.5614,
    width: 1.14121,
    height: 59.1341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9035_2253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9035_2253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter15_d_9035_2253",
    x: 62.0468,
    y: 56.493,
    width: 1.14121,
    height: 58.3119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9035_2253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9035_2253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter16_d_9035_2253",
    x: 52.0468,
    y: 51.41,
    width: 1.14121,
    height: 57.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9035_2253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9035_2253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-company_svg__filter17_d_9035_2253",
    x: 43.0468,
    y: 46.41,
    width: 1.14121,
    height: 57.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9035_2253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9035_2253",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint0_linear_9035_2253",
    x1: 61.3709,
    y1: 24.8695,
    x2: 49.9578,
    y2: 48.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint1_linear_9035_2253",
    x1: 40.5419,
    y1: 44.2718,
    x2: 40.5419,
    y2: 103.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint2_linear_9035_2253",
    x1: 40.4104,
    y1: 59.4752,
    x2: 40.4104,
    y2: 103.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C579B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint3_linear_9035_2253",
    x1: 72.1234,
    y1: 115,
    x2: 72.1234,
    y2: 122.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint4_linear_9035_2253",
    x1: 72.1233,
    y1: 115,
    x2: 72.1233,
    y2: 122.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint5_linear_9035_2253",
    x1: 98.1234,
    y1: 101,
    x2: 98.1234,
    y2: 108.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint6_linear_9035_2253",
    x1: 98.1233,
    y1: 101,
    x2: 98.1233,
    y2: 108.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint7_linear_9035_2253",
    x1: 27.1234,
    y1: 91,
    x2: 27.1234,
    y2: 98.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-company_svg__paint8_linear_9035_2253",
    x1: 27.1233,
    y1: 91,
    x2: 27.1233,
    y2: 98.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCompany);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-company.485f9c6d.svg";